var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info_icon",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11273",
    "data-name": "Path 11273",
    d: "M17.5,10A7.5,7.5,0,1,1,10,2.5,7.507,7.507,0,0,1,17.5,10ZM10,3.684A6.316,6.316,0,1,0,16.316,10,6.314,6.314,0,0,0,10,3.684Zm.789,10.2V9.147A.782.782,0,0,0,10,8.358h0a.782.782,0,0,0-.789.789v4.737a.782.782,0,0,0,.789.789h0A.782.782,0,0,0,10.789,13.884ZM10,5.326a1.105,1.105,0,1,0,1.105,1.105A1.1,1.1,0,0,0,10,5.326Z",
    fill: "#1e1a33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.5810306d172b71ca24b0802021e0e15e.svg";
export { ForwardRef as ReactComponent };